import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { PageHeader } from '../components/PageHeader';
import { ContentCard } from '../components/ContentCard';
import { PhoneCallIcon, ShieldIcon, CameraIcon, UsersIcon, FileTextIcon, HeartPulseIcon, ScaleIcon, MessageSquareOffIcon } from 'lucide-react';
const steps = [{
  number: 1,
  title: 'Check for Injuries & Call 911',
  description: 'Your safety comes first. Check yourself and others for injuries. Call 911 immediately, even for minor accidents.',
  variant: 'warning' as const
}, {
  number: 2,
  title: 'Move to Safety',
  description: 'If possible, move yourself and your bike out of traffic. Turn on hazard lights. Never leave the scene of an accident.',
  variant: 'important' as const
}, {
  number: 3,
  title: 'Document Everything',
  description: 'Take photos of all damage, road conditions, traffic signs, license plates, and the overall scene. More photos are better than fewer.',
  variant: 'tip' as const
}, {
  number: 4,
  title: 'Get Witness Information',
  description: 'Collect names, phone numbers, and statements from any witnesses. Their testimony can be crucial for your case.',
  variant: 'default' as const
}, {
  number: 5,
  title: 'Exchange Insurance Info',
  description: "Get the other driver's insurance details, but DO NOT discuss fault or apologize. Stick to exchanging information only.",
  variant: 'warning' as const
}, {
  number: 6,
  title: 'Seek Medical Attention',
  description: "Get checked by a doctor even if you feel fine. Adrenaline masks pain. Some injuries don't show symptoms for days.",
  variant: 'important' as const
}, {
  number: 7,
  title: 'Contact a Lawyer First',
  description: 'Before giving any recorded statement to insurance companies, consult with an attorney. Insurers are not on your side.',
  variant: 'tip' as const
}, {
  number: 8,
  title: 'Stay Off Social Media',
  description: 'Do not post about the accident online. Insurance companies and lawyers monitor social media. Anything you post can be used against you.',
  variant: 'warning' as const
}];
const container = {
  hidden: {
    opacity: 0
  },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.08
    }
  }
};
const item = {
  hidden: {
    opacity: 0,
    y: 20
  },
  show: {
    opacity: 1,
    y: 0
  }
};
export function TipsAfterCrash() {
  return <div className="min-h-screen bg-[#0a0a0a] safe-bottom" data-id="element-328">
      <PageHeader title="Tips After a Crash" subtitle="Critical steps to protect yourself" urgent data-id="element-329" />

      <main className="px-4 py-6" data-id="element-330">
        {/* Emergency Banner */}
        <motion.div className="bg-[#dc2626] rounded-2xl p-4 mb-6" initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} data-id="element-331">
          <p className="text-white font-bold text-lg mb-1" data-id="element-332">In an Emergency?</p>
          <p className="text-white/90 text-sm mb-3" data-id="element-333">
            Call 911 first, then contact us for immediate legal help.
          </p>
          <a href="tel:+1234567890" className="inline-flex items-center gap-2 bg-white text-[#dc2626] font-semibold px-4 py-2 rounded-xl" data-id="element-334">
            <PhoneCallIcon className="w-4 h-4" data-id="element-335" />
            Call Now
          </a>
        </motion.div>

        <motion.div className="space-y-3" variants={container} initial="hidden" animate="show" data-id="element-336">
          {steps.map(step => <motion.div key={step.number} variants={item} data-id="element-337">
              <ContentCard number={step.number} title={step.title} description={step.description} variant={step.variant} data-id="element-338" />
            </motion.div>)}
        </motion.div>
      </main>
    </div>;
}